module.exports = __webpack_public_path__ + "static/media/end-bg.2b04bd3a.mp4";